document.addEventListener('DOMContentLoaded', function() {
  if (typeof Glide === 'undefined') {
    console.warn('Glide.js is not loaded.');
    return;
  }

  const mobileQuery = window.matchMedia('(max-width: 767px)');
  const tabletQuery = window.matchMedia('(min-width: 768px) and (max-width: 820px)');
  const tablet2Query = window.matchMedia('(min-width: 821px) and (max-width: 1024px)');
  const desktopQuery = window.matchMedia('(min-width: 1025px)');
  let videosSlider;

  // ---- Video pagination & play logic ----
  function updateVideoPagination(index) {
    document.querySelectorAll('.jade-plus_video-pagination button').forEach(function(btn, i) {
      btn.classList.toggle('active', i === index);
    });
  }

  function stopAllVideos() {
    document.querySelectorAll('.jade-plus_video-thumbnail iframe').forEach(function(iframe) {
      var thumb = iframe.closest('.jade-plus_video-thumbnail');
      var videoId = thumb.dataset.videoId;
      // Remove iframe and restore thumbnail + play button
      thumb.innerHTML =
        '<img src="https://img.youtube.com/vi/' + videoId + '/hqdefault.jpg" alt="" loading="lazy">' +
        '<div class="jade-plus_video-play-btn">' +
          '<svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">' +
            '<circle cx="24" cy="24" r="23.5" fill="#00C3FF" stroke="#00C3FF"/>' +
            '<path d="M20.5 18.5C20.5 18.2239 20.7761 18 21.1094 18.1925L31 24L21.1094 29.8075C20.7761 30 20.5 29.7761 20.5 29.5V18.5Z" fill="#0A0C0B"/>' +
          '</svg>' +
        '</div>';
    });
  }

  function initVideoInteractions() {
    // Thumbnail click → load iframe (stop any other playing video first)
    document.querySelectorAll('.jade-plus_video-thumbnail').forEach(function(thumb) {
      thumb.addEventListener('click', function() {
        var videoId = thumb.dataset.videoId;
        if (!videoId || thumb.querySelector('iframe')) return;
        stopAllVideos();
        var iframe = document.createElement('iframe');
        iframe.src = 'https://www.youtube.com/embed/' + videoId + '?autoplay=1&rel=0';
        iframe.allow = 'autoplay; encrypted-media';
        iframe.allowFullscreen = true;
        // Remove thumbnail elements and insert iframe
        thumb.innerHTML = '';
        thumb.appendChild(iframe);
      });
    });

    // Pagination dot clicks
    document.querySelectorAll('.jade-plus_video-pagination button').forEach(function(btn) {
      btn.addEventListener('click', function() {
        var idx = parseInt(btn.dataset.index, 10);
        if (videosSlider) videosSlider.go('=' + idx);
      });
    });
  }

  function mountVideosSlider(config) {
    if (videosSlider) return;
    videosSlider = new Glide('.jade-plus_video-glide', config).mount();
    updateVideoPagination(0);
    videosSlider.on('run', function() {
      updateVideoPagination(videosSlider.index);
    });
  }

  function initializeSliders() {
    if (mobileQuery.matches) {
      // Mobile configuration
      try {
        mountVideosSlider({
          type: 'slider',
          perView: 1,
          gap: 32,
          peek: { before: 0, after: 0 },
          animationDuration: 400,
          swipeThreshold: 80,
          dragThreshold: 120,
          rewind: false,
          bound: true
        });
      } catch (error) {
        console.error('Error initializing Glide sliders:', error);
      }
    } else if (tabletQuery.matches) {
      // Tablet configuration (768px-820px)
      try {
        mountVideosSlider({
          type: 'slider',
          perView: 1,
          gap: 20,
          peek: { before: 0, after: 0 },
          animationDuration: 400,
          swipeThreshold: 80,
          dragThreshold: 120,
          rewind: false,
          bound: true
        });
      } catch (error) {
        console.error('Error initializing Glide sliders:', error);
      }
    } else if (tablet2Query.matches) {
      // Tablet2 configuration (821px-1024px)
      try {
        mountVideosSlider({
          type: 'slider',
          perView: 1,
          gap: 20,
          peek: { before: 0, after: 0 },
          animationDuration: 400,
          swipeThreshold: 80,
          dragThreshold: 120,
          rewind: false,
          bound: true
        });
      } catch (error) {
        console.error('Error initializing Glide sliders:', error);
      }
    } else if (desktopQuery.matches) {
      // Desktop configuration (≥1025px)
      try {
        mountVideosSlider({
          type: 'slider',
          perView: 3,
          gap: 20,
          peek: { before: 0, after: 0 },
          animationDuration: 400,
          swipeThreshold: 80,
          dragThreshold: 120,
          rewind: false,
          bound: true
        });
      } catch (error) {
        console.error('Error initializing video Glide slider:', error);
      }
    }
  }

  function handleWidthChange() {
    // Destroy existing sliders
    if (videosSlider) {
      videosSlider.destroy();
      videosSlider = null;
    }

    // Reinitialize with new settings
    initializeSliders();
  }

  // Initial setup
  initializeSliders();
  initVideoInteractions();

  // Listen for screen size changes
  mobileQuery.addEventListener('change', handleWidthChange);
  tabletQuery.addEventListener('change', handleWidthChange);
  tablet2Query.addEventListener('change', handleWidthChange);
  desktopQuery.addEventListener('change', handleWidthChange);
});
